import { render } from "./ItemCategoryFields.vue?vue&type=template&id=dd45cd42"
import script from "./ItemCategoryFields.vue?vue&type=script&lang=js"
export * from "./ItemCategoryFields.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__